import * as tw from 'src/lib/tailwindClasses';

interface ButtonGroupSwitchProps {
  options: {label: string; value: string}[];
  selectedValue: string;
  onChange: (value: string) => void;
}

// shared style definitions
const baseButtonStyles = 'relative inline-flex items-center px-3 py-2 text-sm';
const activeStyles = 'bg-blue-50 text-blue-600 hover:bg-gray-100';
const inactiveStyles = 'bg-white text-gray-900 inset-ring-1 inset-ring-gray-300 hover:bg-gray-50';

export const ButtonGroupSwitch: React.FC<ButtonGroupSwitchProps> = ({
  options,
  selectedValue,
  onChange,
}) => {
  return (
    <div className={`isolate inline-flex ${tw.ringBorder}`} role="group">
      {options.map((option) => (
        <button
          type="button"
          className={`${baseButtonStyles} rounded-none font-weight-medium   ${
            option.value === selectedValue ? activeStyles : inactiveStyles
          }`}
          key={option.value}
          onClick={() => onChange(option.value)}
        >
          {option.label}
        </button>
      ))}
    </div>
  );
};
